(function ($) {
  $(function () {
    $('button.tab').click(function () {
      let tabId = $(this).attr('data-tabid');
      // Remove active classes
      $('button.tab').children('.tab-position').removeClass('active');
      $('.tabbed_page .tab')
        .removeClass('active')
        .delay(1000)
        .addClass('d-none');
      // Add active classes
      $(this).children('.tab-position').eq(0).addClass('active');
      $(`.tabbed_page .tab#${tabId}`)
        .addClass('active')
        .delay(1000)
        .removeClass('d-none');
    });
  });
})(jQuery);
